import { Injectable } from '@angular/core';
import Dexie from 'dexie';

interface Storage {
  id: string;
  data: any;
}

@Injectable({
  providedIn: 'root',
})
export class IDBService {
  private db: Dexie;
  private table: Dexie.Table<any> = null;

  private dbName = 'anflexDB';
  private dbVersion = 1;
  private storeName = 'anflexStore';

  constructor() {
    this.db = new Dexie(this.dbName);
    this.db.version(this.dbVersion).stores({
      anflexStore: 'id',
    });
    this.table = this.db.table(this.storeName);
  }

  async insert(id: string, data: any): Promise<any> {
    const storage: Storage = {
      id,
      data,
    };
    return await this.table.add(storage);
  }

  async update(id: string, data: any): Promise<any> {
    const storage: Storage = {
      id,
      data,
    };
    return await this.table.put(storage);
  }

  async delete(id: string): Promise<void> {
    return await this.table.delete(id);
  }

  async getById(id: string): Promise<any | undefined> {
    return await this.table.get({ id });
  }
}
